import React from 'react';
import Avatar from 'v2/Avatar/Avatar';
import { ArrowUpRightFromSquare } from 'v2/icons';
import styles from './styles.module.scss';

type LinkEntityBodyTitle = {
  text: string;
  url: string;
};

type LinkEntityBodyProps = {
  avatar: string;
  title: LinkEntityBodyTitle;
  subtitle: string;
  description?: string;
};

export function LinkEntityBody({
  avatar,
  title,
  subtitle,
  description,
}: LinkEntityBodyProps) {
  return (
    <div className={styles.linkEntityBodyContainer}>
      <Avatar url={avatar} />

      <div className={styles.linkEntityDetails}>
        <div className={styles.titleContainer}>
          <a
            href={title.url}
            className={styles.title}
            target="_blank"
            rel="noreferrer"
          >
            {title.text} <ArrowUpRightFromSquare className="mt-n1 ml-1" />
          </a>
        </div>

        <p className={styles.subtitle}>{subtitle}</p>

        {description && <p className={styles.description}>{description}</p>}
      </div>
    </div>
  );
}
